import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

export default function PaymentCancel() {
  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col items-start justify-center px-6 py-40" data-testid="payment-cancel-page">
      <FadeUp>
        <h1 className="font-serif text-5xl tracking-tight text-forest">Pagamento annullato.</h1>
        <p className="mt-4 max-w-md leading-relaxed text-sage">
          Nessun addebito è stato effettuato. Il tuo carrello è ancora lì che ti aspetta, come una pianta in serra.
        </p>
        <Link to="/negozio" data-testid="cancel-back-shop" className="mt-10 inline-flex items-center gap-2 rounded-full bg-forest px-10 py-4 font-accent text-sm uppercase tracking-[0.2em] text-bone transition-transform duration-300 hover:scale-105 active:scale-95">
          <ArrowLeft className="h-4 w-4" strokeWidth={1.5} /> Torna al negozio
        </Link>
      </FadeUp>
    </main>
  );
}
